<template>
    <div v-show="listtabs.length > 0 || showsingletab == true" v-bind:class="[classstyle]">
        <div class="nav-scroll-x">
            <ul class="nav nav-underlined">
                <li class="nav-item" v-for="(tab, index) in listtabs" :key="index">
                    <a class="nav-link" v-bind:class="[tab == curTab ? 'active' : '', tab.disabled ? 'disabled' : '']" @click="selectTab(tab)" href="javascript:;" v-html="tab.content"></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            classstyle: { default: function () { return ''; }},
            listtabs: { default: function () { return []; } },
            showsingletab: {function() { return true; }},
            defaulttab: { default: function () { return null;} } 
        },
        data: function(){
            return {
                curTab:null
            }
        },
        computed: {
            
        },
        watch: { 
           defaulttab(newValue, oldValue) {
               this.curTab = newValue;
            },
            listtabs(newValue, oldValue) {
                if (this.curTab == null) this.curTab = newValue[0];
            }
        },
        mounted(){
            this.curTab = this.defaulttab;
            if (!this.curTab && this.listtabs.length > 0) this.curTab = this.listtabs[0];
            this.$emit("on-tab-click", {
                        tab:this.curTab
                });
        },
        methods: {
            selectTab(tab) {
                if (!tab) return;
                if (tab.disabled) return this.$emit("on-tab-disabled-click", {
                        tab:tab
                });
                this.curTab = tab;
                this.$emit("on-tab-click", {
                        tab:tab
                });
            },
            
        }
    }
</script>